// extracted by mini-css-extract-plugin
module.exports = {"statusContainer":"expenses_statusContainer_3fQ2A","statusLoadingIcon":"expenses_statusLoadingIcon_32zuU"};